export default __webpack_public_path__ + "static/media/check-authorizations-fr.1bf86e7b.png";